// extracted by mini-css-extract-plugin
module.exports = {"concept":"styles_concept__2F0Hb","focused":"styles_focused__1JMt0"};